export const BOTTOM_TAB_KEY = {
  NETWORK: 'network',
  PERFORMANCE: 'performance',
  ACCESSIBILITY: 'accessibility',
  CONSOLE: 'console',
  ERROR_AND_CRASH_REPORTING: 'error-and-crash-reporting',
  DEVICE_VITALS: 'device-vitals',
};

export const NO_TAB_MATCH = Object.freeze(
  { show: false, activeTab: null },
);

export const APP_STORAGE_KIND = Object.freeze({
  IOS: 'ios',
  ANDROID: 'android',
  OTHER: 'other',
});

export const DEVICE_VITALS_EMPTY_STATE = Object.freeze({
  title: 'No device information available',
  subTitle: 'We were unable to retrieve any information about your device vitals for this testing session.',
});

export const CHARTS_SYNC_ID = 'device-vitals';

export const TRACK_USER_VIEWED_JOBS = 'TRACK_USER_VIEWED_JOBS';
